export default __webpack_public_path__ + "static/media/botao_editar_locucao.81eb1235.svg";